import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '../shared/fi-state-proxy/fi-state-names';
import { FiSiteDesignComponent } from './fi-site-design.component';
import { FiSiteDesignSettingsComponent } from './fi-site-design-settings/fi-site-design-settings.component';
import { FiSiteDesignService } from '@fi-shared/fi-shared-services/fi-site-design.service';
import { FiStateService } from '../shared/fi-state-proxy/fi-state.proxy.service';
import { FiSiteDesignBrandEditorComponent } from './fi-site-design-settings/fi-site-design-brand-editor/fi-site-design-brand-editor.component';
import { FiSiteDesignHelperService } from './fi-site-design-helper.service';
import { BusinessAreaService } from '@fi-app/business-area/business-area.service';

const SiteDesignState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.SiteDesign._name,
    url: '/SiteDesign',
    abstract: true,
    views: {
        '@': {
            component: FiSiteDesignComponent,
        },
    },
};

const SiteDesignSettingsState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.SiteDesign.Settings,
    url: '/Settings',
    component: FiSiteDesignSettingsComponent,
    resolve: {
        siteDesigns: [FiSiteDesignService, SiteDesignSettings_siteDesigns],
    },
};

export function SiteDesignSettings_siteDesigns(siteDesignService: FiSiteDesignService) {
    return siteDesignService.getSiteDesigns();
}

export function SiteDesignSettings_availableBusinessAreas(businessAreaService: BusinessAreaService) {
    return businessAreaService.getLightWeightBusinessAreas();
}

const SiteDesignBrandEditState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.SiteDesign.BrandEdit,
    url: '/Edit/{Id:[0-9]+}',
    component: FiSiteDesignBrandEditorComponent,
    resolve: {
        siteDesign: [FiStateService, Transition, FiSiteDesignService, SiteDesignSettings_siteDesignEdit],
        availableBusinessAreas: [BusinessAreaService, SiteDesignSettings_availableBusinessAreas],
    },
};

export function SiteDesignSettings_siteDesignEdit(
    fiStateService: FiStateService,
    transition: Transition,
    siteDesignService: FiSiteDesignService,
) {
    return siteDesignService.getSiteDesignById(fiStateService.getParams(transition).Id);
}

export const FiSiteDesignStates: StatesModule = {
    states: [SiteDesignState, SiteDesignSettingsState, SiteDesignBrandEditState],
};
